module.exports = __webpack_public_path__ + "img/iconmonstr-minus-circle-thin.bb0b2606.svg";